// extracted by mini-css-extract-plugin
export default {"sk-chase":"styles_sk-chase__3WQG3","sk-chase-dot":"styles_sk-chase-dot__BIczB","sk-chase-dot-before":"styles_sk-chase-dot-before__pjY9A"};